module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gZ6NN"))).then(() => module.bundle.root('jnagv'));